import { render, staticRenderFns } from "./sys_module.vue?vue&type=template&id=2d80db9c"
import script from "./sys_module.vue?vue&type=script&lang=js"
export * from "./sys_module.vue?vue&type=script&lang=js"
import style0 from "./sys_module.vue?vue&type=style&index=0&id=2d80db9c&prod&lang=css"
import style1 from "./sys_module.vue?vue&type=style&index=1&id=2d80db9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports